import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SubEditor extends Component {
  static propTypes = {
    onValueChange: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    discard: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
  }

  render() {
    return (
      <div className="ColorBlock-panel">
        <textarea
          className="ColorBlock-texValue"
          onChange={this.props.onValueChange}
          ref="textarea"
          value={this.props.text}
        />
        <div className="ColorBlock-buttons">
          <button
            className="ColorBlock-discardButton"
            onClick={this.props.discard}
          >
            {'Discard'}
          </button>
          <button
            className="ColorBlock-saveButton"
            onClick={this.props.save}
          >
            {'Save'}
          </button>
        </div>
      </div>
    )
  }
}

export default SubEditor



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/ColorBlock/SubEditor.js